<ng-container [formGroup]="creditCardForm">
    <div class="flex flex-column gap-2 mb-2">
        <div class="flex flex-row">
            <div class="flex flex-column gap-1 flex-1">
                <span class="text-sm font-bold"><app-translate key="CARDHOLDER_NAME"></app-translate> <span
                        class="text-red-500">*</span></span>
                <div class="cc-input-width">
                    <input pInputText class="w-full" formControlName="cardholderName"
                        (keypress)="onlyAlphabets($event)" />
                </div>
                <sp-control-error [parameters]="[languageService.getTranslation('CARDHOLDER_NAME')]"
                    [control]="creditCardForm.controls['cardholderName']"></sp-control-error>
            </div>
        </div>
        <div class="flex flex-row">
            <div [ngStyle]="{'width': '140px'}" class="flex flex-column gap-1">
                <span class="text-sm font-bold"><app-translate key="ZIP_CODE"></app-translate> <span
                        class="text-red-500">*</span></span>
                <input pInputText formControlName="zipCode" maxlength="5" inputmode="numeric" pattern="[0-9]*"
                    (keypress)="onlyNumbers($event)" (ngModelChange)="onZipCodeChange($event)" />

                @if (creditCardForm.get('zipCode')?.hasError('sameZipError')) {
                <small class="p-error"><app-translate key="ZIP_CODE_MATCH_ERROR"></app-translate></small>
                } @else if (creditCardForm.get('zipCode')?.touched &&
                creditCardForm.get('zipCode')?.hasError('required')) {
                <small class="p-error"><app-translate key="ZIP_CODE_REQUIRED"></app-translate></small>
                } @else if (creditCardForm.get('zipCode')?.touched &&
                creditCardForm.get('zipCode')?.hasError('pattern')) {
                <small class="p-error"><app-translate key="ENTER_VALID_ZIP"></app-translate></small>
                }
            </div>
        </div>
    </div>
    <div class="mb-2">
        <div class="flex flex-column gap-1 card-container">
            <span class="text-sm font-bold"><app-translate key="CARD_NUMBER"></app-translate> <span
                    class="text-red-500">*</span></span>
            <div class="relative cc-input-width text-sm">
                <p-inputMask type="tel" class="w-full pr-12" formControlName="cardNumber" [maxlength]="19"
                    autocomplete="cc-number" mask="9999-9999-9999-999?9" (ngModelChange)="onCardNumberChange($event)"
                    (onBlur)="onValidateCardNumber()" autoClear="false" />
                <img [src]="cardValidationImage" alt="Card Type" class="card-image" />
            </div>
            @if (creditCardForm.get('cardNumber')?.hasError('invalidCard') || creditCardForm.get('cardNumber')?.hasError('luhn')) {
            <small class="p-error"><app-translate key="INVALID_CARD_NUMBER"></app-translate></small>
            } @else if (creditCardForm.get('cardNumber')?.touched &&
            creditCardForm.get('cardNumber')?.hasError('required')) {
            <small class="p-error"><app-translate key="CARD_NUMBER_REQUIRED"></app-translate></small>
            } @else if (creditCardForm.get('cardNumber')?.touched &&
            creditCardForm.get('cardNumber')?.hasError('pattern')) {
            <small class="p-error"><app-translate key="INVALID_CARD_NUMBER"></app-translate></small>
            } @else if (isCheckingCard) {
            <small><app-translate key="CHECKING_CARD_NUMBER"></app-translate></small>
            }
        </div>
    </div>
    <div class="mb-2">
        <div class="flex flex-row gap-3">
            <div [ngStyle]="{'width': '180px'}" class="flex flex-column gap-1">
                <span class="text-sm font-bold"><app-translate key="EXPIRATION_DATE"></app-translate> <span
                        class="text-red-500">*</span></span>
                <p-inputMask type="tel" formControlName="expirationDate" [maxlength]="7" mask="99/9999"
                    [placeholder]="languageService.getTranslation('MM_YYYY')"
                    (ngModelChange)="onExpirationDateChange($event)" />
                @if (creditCardForm.get('expirationDate')?.hasError('expired')) {
                <small class="p-error"><app-translate key="CARD_EXPIRED"></app-translate></small>
                } @else if (creditCardForm.get('expirationDate')?.hasError('pattern')) {
                <small class="p-error"><app-translate key="INVALID_EXPIRATION_DATE"></app-translate></small>
                } @else if (creditCardForm.get('expirationDate')?.touched &&
                creditCardForm.get('expirationDate')?.hasError('required')) {
                <small class="p-error"><app-translate key="EXPIRATION_DATE_REQUIRED"></app-translate></small>
                }
            </div>
            <div class="flex flex-column gap-1 flex-1">
                <div class="flex justify-content-between align-items-center">
                    <span class="text-sm font-bold"><app-translate key="CVV"></app-translate> <span
                            class="text-red-500">*</span></span>
                </div>
                <p-password [ngStyle]="{'max-width': '180px'}" formControlName="cvv" [maxLength]="4"
                    (keypress)="onlyNumbers($event)" [toggleMask]="true" [feedback]="false"
                    (ngModelChange)="onCvvChange($event)" />
                <sp-control-error [parameters]="[languageService.getTranslation('CVV')]"
                    [control]="creditCardForm.controls['cvv']"></sp-control-error>
            </div>
        </div>
    </div>
</ng-container>